module.exports = __webpack_public_path__ + "assets/img/emerald.ac02b961.png";